import store from '@/store'
import { OIDC_STORE_MODULE } from '@/../GjirafaFront/script/auth'
import jwtDefaultConfig from './jwtDefaultConfig'
import { addController, removeController } from '@/services/controllers'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  counter = 1

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    Object.values(axiosIns).forEach(axios => {
      // Request Interceptor
      axios.interceptors.request.use(
        config => {
          // Get token from localStorage
          const accessToken = this.getToken()

          // If token is present add it to request's Authorization Header
          if (accessToken) {
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
          }

          if (!config.noSignalNeeded) {
            const controller = new AbortController()
            config.signal = controller.signal
            config.counter = this.counter
            addController({
              id: this.counter,
              controller,
            })
            this.counter++
          }

          return config
        },
        error => Promise.reject(error),
      )

      // Add request/response interceptor
      axios.interceptors.response.use(
        response => {
          if (response.config.counter) removeController(response.config.counter)
          return response
        },
        error => {
          if (error.code === 'ERR_CANCELED') {
            const err = { response: { data: { errors: [''] } } }
            return Promise.reject(err)
          }

          const { config, response } = error
          const originalRequest = config

          if (response?.status === 401) {
            if (!this.isAlreadyFetchingAccessToken) {
              this.isAlreadyFetchingAccessToken = true
              this.refreshToken().then(r => {
                this.isAlreadyFetchingAccessToken = false

                // Update accessToken in localStorage
                this.setToken(r.accessToken)
                this.setRefreshToken(r.refreshToken)

                this.onAccessTokenFetched(r.accessToken)
              })
            }
            const retryOriginalRequest = new Promise(resolve => {
              this.addSubscriber(accessToken => {
                // Make sure to assign accessToken according to your response.
                // Check: https://pixinvent.ticksy.com/ticket/2413870
                // Change Authorization header
                originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
                resolve(axios(originalRequest))
              })
            })
            return retryOriginalRequest
          }

          if (originalRequest.counter) removeController(originalRequest.counter)

          return Promise.reject(error)
        },
      )
    })
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  refreshToken() {
    store.dispatch(`${OIDC_STORE_MODULE}/authenticateOidcSilent`).then(() => {
      console.log(this)
    })
  }
}
